import { createMeta } from '~/utils/meta'
// import { CROWDIN_FILE_NAME_BY_LOCALE } from '~/utils/lang'

export default {
  head () {
    return createMeta.call(this, {
      title: `${this.title} | Gaming-Goods`,
      description: `${this.title}: Gaming-Goods ${this.$t(
        'platformDescription'
      )}`,

      sharingTitle: this.title,
      sharingDescription: this.$t('platformDescription')
    })
  },

  asyncData ({ route }) {
    try {
      const translations = {
        'info-about': 'infoAbout',
        'info-contacts': 'infoContacts',
        'info-age-restrictions': 'infoAgeRestrictions',
        'info-anticheat': 'infoAnticheat',
        'info-coins': 'infoCoins',
        'info-cookie-policy': 'infoCookiePolicy',
        'info-overwolf': 'infoOverwolf',
        'info-referral': 'infoReferral',
        'info-risk-disclosure': 'infoRiskDisclosure',
        'info-tickets': 'infoTickets',
        'desktop-howto': 'desktopHowto',
        'info-g-cash': 'vPointsDescription'
      }

      const routeName = route.name?.split('___')[0]
      console.log(route.name)
      let pageContent = ''
      if (routeName in translations) {
        pageContent = translations[routeName]
      }

      return {
        pageContent
      }
    } catch (e) {
      return {
        pageContent: null
      }
    }
  }
}
